// SocialCheck — Kunden-Cockpit (Client-Shell + ClientCockpit) i18n: DE / FR / IT / EN
export const cockpitTranslations = {
  de: {
    nav: {
      sectionActions: "Aktionen", sectionService: "Service",
      dashboard: "Übersicht", pocket: "Foto an KEWAG senden", pocketShort: "Foto senden", freigaben: "Zur Freigabe",
      kalender: "Kalender", report: "Reports", support: "Support", einstellungen: "Einstellungen",
      cockpitLabel: "Kunden-Cockpit", myCockpit: "Mein Cockpit",
      contactTitle: "Ihr Ansprechpartner", supportTeam: "KEWAG Support-Team",
      digitalPartner: "Ihr Digitaler Partner", online: "Alle Systeme online",
      supportTitle: "Support & Beratung", supportAvail: "Wir sind für Sie da.",
      supportHours: "Mo–Fr, 08.00–17.30 Uhr", supportCta: "Support kontaktieren",
      helpUpgrade: "Wir sind für Sie da", helpUpgradeSub: "Hilfe · Support · Paket",
      sectionMain: "Hauptbereich", beitraege: "Beiträge", rechnungen: "Rechnungen", channels: "Kanäle & Add-ons",
      heuteWichtig: "Heute wichtig", statusActive: "aktiv",
      tarifUpgraden: "Tarif upgraden", tarifUpgradenDesc: "Mehr Speicher, mehr Kanäle, mehr Funktionen.",
      upgradeAnfragen: "Upgrade anfragen", supportOeffnen: "Support öffnen", teamAnzeigen: "Team anzeigen",
      welcomeBack: "Willkommen zurück,", fallbackName: "Kunde", logout: "Abmelden",
      aboSpeicher: "Abo & Speicher", speicherMedien: "Medien & Speicher", noNotifications: "Keine Benachrichtigungen.",
    },
    mob: {
      more: "Mehr", menuTitle: "Menü", sections: "Bereiche", close: "Schliessen",
      notifications: "Benachrichtigungen", markAllRead: "Alle gelesen", noNotifications: "Keine Benachrichtigungen.",
      language: "Sprache", switchTenant: "Mandant wechseln",
      kundensichtBadge: "Kundensicht – Sie sehen das Cockpit wie der Kunde", kundensichtExit: "Verlassen",
      tabFreigaben: "Freigaben", aboSpeicher: "Abo & Speicher", speicherMedien: "Medien & Speicher",
    },
    notif: {
      today: "Heute", yesterday: "Gestern", older: "Älter",
      markAllRead: "Alle als gelesen markieren", showAll: "Alle anzeigen", showGrouped: "Gruppiert",
      types: {
        freigabe_reminder: { title: "Freigabe ausstehend", body: "{n} Beiträge warten auf Ihre Freigabe.", body0: "Es warten Beiträge auf Ihre Freigabe." },
        ampel_review: { title: "Neuer Beitrag", body: "Ein neuer Beitrag wartet auf Ihre Entscheidung." },
        freigabe_gesendet: { title: "Zur Freigabe bereit", body: "Ein Beitrag liegt für Sie zur Freigabe bereit." },
        post_live: { title: "Beitrag veröffentlicht", body: "Ihr Beitrag wurde nach Ihrer Freigabe veröffentlicht." },
        support: { title: "Support", body: "Es gibt eine neue Nachricht von KEWAG." },
        post_reply: { title: "Antwort vom KEWAG-Team", body: "KEWAG hat auf Ihre Frage zu einem Beitrag geantwortet." },
        default: { title: "Aktualisierung", body: "Es gibt eine Aktualisierung zu Ihren Beiträgen." },
      },
    },
    cc: {
      mode: "Kunden-Cockpit", welcome: "Willkommen zurück",
      subPre: "Ihr SocialCheck-Cockpit für ", subPost: ". KEWAG erstellt — Sie geben frei.",
      noTenant: "Ihnen ist noch kein Mandant zugewiesen. Bitte kontaktieren Sie KEWAG.",
      loading: "Lädt…", nextSteps: "Nächste Schritte",
      obTitle: "Ihr Start mit SocialCheck", obStep1: "Foto senden", obStep2: "Freigeben", obStep3: "Report ansehen",
      obProgress: "{done} von {total} Schritten erledigt", obAllDone: "Geschafft! Ihr Cockpit läuft.", obHide: "Ausblenden",
      pocketTitle: "Foto an KEWAG senden",
      pocketDesc: "Machen Sie ein Foto — KEWAG macht daraus Ihren nächsten Beitrag. Kein Text, keine Hashtags nötig.",
      pocketCta: "Foto senden",
      approvalsOne: "{n} Beitrag wartet auf Ihre Freigabe", approvalsMany: "{n} Beiträge warten auf Ihre Freigabe",
      approvalsDesc: "Prüfen Sie die vorbereiteten Inhalte und geben Sie sie frei — oder fordern Sie eine Änderung an.",
      approvalsCta: "Jetzt prüfen & freigeben",
      approvalsDoneTitle: "Alles freigegeben",
      approvalsDoneDesc: "Aktuell warten keine Beiträge auf Ihre Freigabe. KEWAG meldet sich, sobald es Neues gibt.",
      reportTitle: "Monatsreport herunterladen",
      reportDescPre: "Ihr PDF-Report für ", reportDescPost: " — Übersicht aller Beiträge und Ampel-Status.",
      reportCta: "Report öffnen", reportCreating: "Erstellt…",
      changeReqOne: "{n} Änderungswunsch in Bearbeitung", changeReqMany: "{n} Änderungswünsche in Bearbeitung",
      changeReqStepDesc: "Sie haben Änderungen angefordert — KEWAG arbeitet daran und legt die Beiträge erneut zur Freigabe vor.",
      reportPdfBtn: "Report als PDF", supportBtn: "Support", supportOpen: "{n} offen",
      reportDownloaded: "Report heruntergeladen", downloadFailed: "Download fehlgeschlagen",
      statusTitle: "Status Ihrer Inhalte",
      changeReqTitle: "Ihre Änderungswünsche", crOpen: "offen", crDone: "erledigt",
      inProgress: "In Bearbeitung", doneLabel: "Erledigt",
      upcomingTitle: "Kommende Beiträge", viewCalendar: "Kalender ansehen", noUpcoming: "Keine geplanten Beiträge.",
      ampel: {
        red: { label: "Rot", desc: "Entwurf / intern" },
        amber: { label: "Orange", desc: "Zur Kundenfreigabe" },
        green: { label: "Grün", desc: "Freigegeben / bereit / live" },
        blau: { label: "Blau", desc: "Veröffentlicht / reportet" },
      },
    },
  },

  fr: {
    nav: {
      sectionActions: "Actions", sectionService: "Service",
      dashboard: "Aperçu", pocket: "Envoyer une photo à KEWAG", pocketShort: "Envoyer une photo", freigaben: "À valider",
      kalender: "Calendrier", report: "Rapports", support: "Support", einstellungen: "Paramètres",
      cockpitLabel: "Cockpit client", myCockpit: "Mon cockpit",
      contactTitle: "Votre interlocuteur", supportTeam: "Équipe support KEWAG",
      digitalPartner: "Votre partenaire digital", online: "Tous les systèmes en ligne",
      supportTitle: "Support & conseil", supportAvail: "Nous sommes là pour vous.",
      supportHours: "Lu–Ve, 08h00–17h30", supportCta: "Contacter le support",
      helpUpgrade: "Nous sommes là pour vous", helpUpgradeSub: "Aide · Support · Forfait",
      sectionMain: "Espace principal", beitraege: "Publications", rechnungen: "Factures", channels: "Canaux & options",
      heuteWichtig: "Important aujourd’hui", statusActive: "actif",
      tarifUpgraden: "Améliorer le forfait", tarifUpgradenDesc: "Plus de stockage, plus de canaux, plus de fonctions.",
      upgradeAnfragen: "Demander une amélioration", supportOeffnen: "Ouvrir le support", teamAnzeigen: "Voir l’équipe",
      welcomeBack: "Bon retour,", fallbackName: "Client", logout: "Se déconnecter",
      aboSpeicher: "Abonnement & stockage", speicherMedien: "Médias & stockage", noNotifications: "Aucune notification.",
    },
    mob: {
      more: "Plus", menuTitle: "Menu", sections: "Espaces", close: "Fermer",
      notifications: "Notifications", markAllRead: "Tout lu", noNotifications: "Aucune notification.",
      language: "Langue", switchTenant: "Changer de mandant",
      kundensichtBadge: "Vue client – vous voyez le cockpit comme le client", kundensichtExit: "Quitter",
      tabFreigaben: "Validations", aboSpeicher: "Abonnement & stockage", speicherMedien: "Médias & stockage",
    },
    notif: {
      today: "Aujourd’hui", yesterday: "Hier", older: "Plus ancien",
      markAllRead: "Tout marquer comme lu", showAll: "Tout afficher", showGrouped: "Groupé",
      types: {
        freigabe_reminder: { title: "Validation en attente", body: "{n} publications attendent votre validation.", body0: "Des publications attendent votre validation." },
        ampel_review: { title: "Nouvelle publication", body: "Une nouvelle publication attend votre décision." },
        freigabe_gesendet: { title: "Prête à valider", body: "Une publication est prête pour votre validation." },
        post_live: { title: "Publication en ligne", body: "Votre publication a été publiée après votre validation." },
        support: { title: "Support", body: "Vous avez un nouveau message de KEWAG." },
        post_reply: { title: "Réponse de l’équipe KEWAG", body: "KEWAG a répondu à votre question sur une publication." },
        default: { title: "Mise à jour", body: "Il y a une mise à jour concernant vos publications." },
      },
    },
    cc: {
      mode: "Cockpit client", welcome: "Bon retour",
      subPre: "Votre cockpit SocialCheck pour ", subPost: ". KEWAG crée — vous validez.",
      noTenant: "Aucun mandant ne vous est encore attribué. Veuillez contacter KEWAG.",
      loading: "Chargement…", nextSteps: "Prochaines étapes",
      obTitle: "Vos débuts avec SocialCheck", obStep1: "Envoyer une photo", obStep2: "Valider", obStep3: "Voir le rapport",
      obProgress: "{done} sur {total} étapes terminées", obAllDone: "Bravo ! Votre cockpit tourne.", obHide: "Masquer",
      pocketTitle: "Envoyer une photo à KEWAG",
      pocketDesc: "Prenez une photo — KEWAG en fait votre prochaine publication. Aucun texte ni hashtag nécessaire.",
      pocketCta: "Envoyer une photo",
      approvalsOne: "{n} publication en attente de validation", approvalsMany: "{n} publications en attente de validation",
      approvalsDesc: "Vérifiez les contenus préparés et validez-les — ou demandez une modification.",
      approvalsCta: "Vérifier & valider",
      approvalsDoneTitle: "Tout est validé",
      approvalsDoneDesc: "Aucune publication n’attend votre validation. KEWAG vous contacte dès qu’il y a du nouveau.",
      reportTitle: "Télécharger le rapport mensuel",
      reportDescPre: "Votre rapport PDF pour ", reportDescPost: " — aperçu de toutes les publications et statut des feux.",
      reportCta: "Ouvrir le rapport", reportCreating: "Création…",
      changeReqOne: "{n} demande de modification en cours", changeReqMany: "{n} demandes de modification en cours",
      changeReqStepDesc: "Vous avez demandé des modifications — KEWAG s’en occupe et soumet à nouveau les publications à validation.",
      reportPdfBtn: "Rapport en PDF", supportBtn: "Support", supportOpen: "{n} ouvert(s)",
      reportDownloaded: "Rapport téléchargé", downloadFailed: "Échec du téléchargement",
      statusTitle: "Statut de vos contenus",
      changeReqTitle: "Vos demandes de modification", crOpen: "en cours", crDone: "traitées",
      inProgress: "En cours", doneLabel: "Traité",
      upcomingTitle: "Publications à venir", viewCalendar: "Voir le calendrier", noUpcoming: "Aucune publication planifiée.",
      ampel: {
        red: { label: "Rouge", desc: "Brouillon / interne" },
        amber: { label: "Orange", desc: "À valider par le client" },
        green: { label: "Vert", desc: "Validé / prêt / en ligne" },
        blau: { label: "Bleu", desc: "Publié / rapporté" },
      },
    },
  },

  it: {
    nav: {
      sectionActions: "Azioni", sectionService: "Servizio",
      dashboard: "Panoramica", pocket: "Invia una foto a KEWAG", pocketShort: "Invia foto", freigaben: "Da approvare",
      kalender: "Calendario", report: "Report", support: "Supporto", einstellungen: "Impostazioni",
      cockpitLabel: "Cockpit cliente", myCockpit: "Il mio cockpit",
      contactTitle: "Il tuo referente", supportTeam: "Team supporto KEWAG",
      digitalPartner: "Il tuo partner digitale", online: "Tutti i sistemi online",
      supportTitle: "Supporto & consulenza", supportAvail: "Siamo qui per te.",
      supportHours: "Lu–Ve, 08.00–17.30", supportCta: "Contatta il supporto",
      helpUpgrade: "Siamo qui per lei", helpUpgradeSub: "Aiuto · Supporto · Pacchetto",
      sectionMain: "Area principale", beitraege: "Post", rechnungen: "Fatture", channels: "Canali & extra",
      heuteWichtig: "Importante oggi", statusActive: "attivo",
      tarifUpgraden: "Aggiorna il piano", tarifUpgradenDesc: "Più spazio, più canali, più funzioni.",
      upgradeAnfragen: "Richiedi upgrade", supportOeffnen: "Apri il supporto", teamAnzeigen: "Mostra il team",
      welcomeBack: "Bentornato,", fallbackName: "Cliente", logout: "Esci",
      aboSpeicher: "Abbonamento & spazio", speicherMedien: "Media & spazio", noNotifications: "Nessuna notifica.",
    },
    mob: {
      more: "Altro", menuTitle: "Menu", sections: "Aree", close: "Chiudi",
      notifications: "Notifiche", markAllRead: "Tutte lette", noNotifications: "Nessuna notifica.",
      language: "Lingua", switchTenant: "Cambia mandante",
      kundensichtBadge: "Vista cliente – vedi il cockpit come il cliente", kundensichtExit: "Esci",
      tabFreigaben: "Approvazioni", aboSpeicher: "Abbonamento & spazio", speicherMedien: "Media & spazio",
    },
    notif: {
      today: "Oggi", yesterday: "Ieri", older: "Meno recenti",
      markAllRead: "Segna tutte come lette", showAll: "Mostra tutte", showGrouped: "Raggruppate",
      types: {
        freigabe_reminder: { title: "Approvazione in sospeso", body: "{n} post attendono la tua approvazione.", body0: "Alcuni post attendono la tua approvazione." },
        ampel_review: { title: "Nuovo post", body: "Un nuovo post attende la tua decisione." },
        freigabe_gesendet: { title: "Pronto per l’approvazione", body: "Un post è pronto per la tua approvazione." },
        post_live: { title: "Post pubblicato", body: "Il tuo post è stato pubblicato dopo la tua approvazione." },
        support: { title: "Supporto", body: "Hai un nuovo messaggio da KEWAG." },
        post_reply: { title: "Risposta del team KEWAG", body: "KEWAG ha risposto alla tua domanda su un post." },
        default: { title: "Aggiornamento", body: "C’è un aggiornamento sui tuoi post." },
      },
    },
    cc: {
      mode: "Cockpit cliente", welcome: "Bentornato",
      subPre: "Il tuo cockpit SocialCheck per ", subPost: ". KEWAG crea — tu approvi.",
      noTenant: "Non ti è ancora stato assegnato alcun mandante. Contatta KEWAG.",
      loading: "Caricamento…", nextSteps: "Prossimi passi",
      obTitle: "Il tuo avvio con SocialCheck", obStep1: "Invia foto", obStep2: "Approva", obStep3: "Vedi report",
      obProgress: "{done} di {total} passi completati", obAllDone: "Fatto! Il tuo cockpit è attivo.", obHide: "Nascondi",
      pocketTitle: "Invia una foto a KEWAG",
      pocketDesc: "Scatta una foto — KEWAG la trasforma nel tuo prossimo post. Nessun testo né hashtag necessari.",
      pocketCta: "Invia foto",
      approvalsOne: "{n} post in attesa della tua approvazione", approvalsMany: "{n} post in attesa della tua approvazione",
      approvalsDesc: "Controlla i contenuti preparati e approvali — oppure richiedi una modifica.",
      approvalsCta: "Controlla & approva",
      approvalsDoneTitle: "Tutto approvato",
      approvalsDoneDesc: "Al momento nessun post attende la tua approvazione. KEWAG ti avvisa appena ci sono novità.",
      reportTitle: "Scarica il report mensile",
      reportDescPre: "Il tuo report PDF per ", reportDescPost: " — panoramica di tutti i post e stato del semaforo.",
      reportCta: "Apri report", reportCreating: "Creazione…",
      changeReqOne: "{n} richiesta di modifica in corso", changeReqMany: "{n} richieste di modifica in corso",
      changeReqStepDesc: "Hai richiesto modifiche — KEWAG ci sta lavorando e ripresenta i post per l’approvazione.",
      reportPdfBtn: "Report in PDF", supportBtn: "Supporto", supportOpen: "{n} aperti",
      reportDownloaded: "Report scaricato", downloadFailed: "Download non riuscito",
      statusTitle: "Stato dei tuoi contenuti",
      changeReqTitle: "Le tue richieste di modifica", crOpen: "in corso", crDone: "completate",
      inProgress: "In corso", doneLabel: "Completato",
      upcomingTitle: "Prossimi post", viewCalendar: "Vedi calendario", noUpcoming: "Nessun post pianificato.",
      ampel: {
        red: { label: "Rosso", desc: "Bozza / interno" },
        amber: { label: "Arancione", desc: "Da approvare" },
        green: { label: "Verde", desc: "Approvato / pronto / live" },
        blau: { label: "Blu", desc: "Pubblicato / nel report" },
      },
    },
  },

  en: {
    nav: {
      sectionActions: "Actions", sectionService: "Service",
      dashboard: "Overview", pocket: "Send a photo to KEWAG", pocketShort: "Send photo", freigaben: "For approval",
      kalender: "Calendar", report: "Reports", support: "Support", einstellungen: "Settings",
      cockpitLabel: "Client cockpit", myCockpit: "My cockpit",
      contactTitle: "Your contact", supportTeam: "KEWAG support team",
      digitalPartner: "Your digital partner", online: "All systems online",
      supportTitle: "Support & advice", supportAvail: "We're here for you.",
      supportHours: "Mon–Fri, 08:00–17:30", supportCta: "Contact support",
      helpUpgrade: "We're here for you", helpUpgradeSub: "Help · Support · Plan",
      sectionMain: "Main area", beitraege: "Posts", rechnungen: "Invoices", channels: "Channels & add-ons",
      heuteWichtig: "Important today", statusActive: "active",
      tarifUpgraden: "Upgrade plan", tarifUpgradenDesc: "More storage, more channels, more features.",
      upgradeAnfragen: "Request upgrade", supportOeffnen: "Open support", teamAnzeigen: "View team",
      welcomeBack: "Welcome back,", fallbackName: "Client", logout: "Sign out",
      aboSpeicher: "Plan & storage", speicherMedien: "Media & storage", noNotifications: "No notifications.",
    },
    mob: {
      more: "More", menuTitle: "Menu", sections: "Areas", close: "Close",
      notifications: "Notifications", markAllRead: "Mark all read", noNotifications: "No notifications.",
      language: "Language", switchTenant: "Switch client",
      kundensichtBadge: "Client view – you see the cockpit as the client does", kundensichtExit: "Exit",
      tabFreigaben: "Approvals", aboSpeicher: "Plan & storage", speicherMedien: "Media & storage",
    },
    notif: {
      today: "Today", yesterday: "Yesterday", older: "Earlier",
      markAllRead: "Mark all as read", showAll: "Show all", showGrouped: "Grouped",
      types: {
        freigabe_reminder: { title: "Approval pending", body: "{n} posts are awaiting your approval.", body0: "Posts are awaiting your approval." },
        ampel_review: { title: "New post", body: "A new post is awaiting your decision." },
        freigabe_gesendet: { title: "Ready for approval", body: "A post is ready for your approval." },
        post_live: { title: "Post published", body: "Your post was published after your approval." },
        support: { title: "Support", body: "You have a new message from KEWAG." },
        post_reply: { title: "Reply from the KEWAG team", body: "KEWAG replied to your question about a post." },
        default: { title: "Update", body: "There's an update on your posts." },
      },
    },
    cc: {
      mode: "Client cockpit", welcome: "Welcome back",
      subPre: "Your SocialCheck cockpit for ", subPost: ". KEWAG creates — you approve.",
      noTenant: "No client account has been assigned to you yet. Please contact KEWAG.",
      loading: "Loading…", nextSteps: "Next steps",
      obTitle: "Your start with SocialCheck", obStep1: "Send photo", obStep2: "Approve", obStep3: "View report",
      obProgress: "{done} of {total} steps done", obAllDone: "All set! Your cockpit is live.", obHide: "Hide",
      pocketTitle: "Send a photo to KEWAG",
      pocketDesc: "Take a photo — KEWAG turns it into your next post. No text or hashtags needed.",
      pocketCta: "Send photo",
      approvalsOne: "{n} post awaiting your approval", approvalsMany: "{n} posts awaiting your approval",
      approvalsDesc: "Review the prepared content and approve it — or request a change.",
      approvalsCta: "Review & approve now",
      approvalsDoneTitle: "Everything approved",
      approvalsDoneDesc: "No posts are currently awaiting your approval. KEWAG will get in touch as soon as there’s something new.",
      reportTitle: "Download monthly report",
      reportDescPre: "Your PDF report for ", reportDescPost: " — overview of all posts and traffic-light status.",
      reportCta: "Open report", reportCreating: "Creating…",
      changeReqOne: "{n} change request in progress", changeReqMany: "{n} change requests in progress",
      changeReqStepDesc: "You requested changes — KEWAG is working on them and will resubmit the posts for approval.",
      reportPdfBtn: "Report as PDF", supportBtn: "Support", supportOpen: "{n} open",
      reportDownloaded: "Report downloaded", downloadFailed: "Download failed",
      statusTitle: "Status of your content",
      changeReqTitle: "Your change requests", crOpen: "open", crDone: "done",
      inProgress: "In progress", doneLabel: "Done",
      upcomingTitle: "Upcoming posts", viewCalendar: "View calendar", noUpcoming: "No scheduled posts.",
      ampel: {
        red: { label: "Red", desc: "Draft / internal" },
        amber: { label: "Amber", desc: "For client approval" },
        green: { label: "Green", desc: "Approved / ready / live" },
        blau: { label: "Blue", desc: "Published / reported" },
      },
    },
  },
};
